import React from 'react';
import { Check, X } from 'lucide-react';
export function ForYouSection() {
  const forYouItems = ['Eres mujer y quieres un ingreso extra desde casa', 'Solo tienes tu celular y ratos libres', 'Quieres algo simple (sin cursos eternos)', 'Te gustaría vender por Instagram y WhatsApp a tu ritmo', 'Quieres empezar con un producto fácil: un PDF'];
  const notForYouItems = ["Buscas hacerte rica 'sin hacer nada'", 'No estás dispuesta a dedicar 1–2 horas al día por una semana', 'Quieres un negocio con inventario, envíos o complicaciones'];
  return <section className="py-8 px-6 bg-gradient-to-b from-[#FFF8E7] to-[#FFF0D4]" data-id="element-85">
      <div className="max-w-2xl mx-auto" data-id="element-86">
        {/* Card 1: Es para ti */}
        <div className="bg-white rounded-2xl p-5 shadow-lg border-2 border-[#FFCAD4]" data-id="element-87">
          <h3 className="text-[18px] md:text-[20px] font-bold text-[#222222] mb-5 text-center" data-id="element-88">
            Mujer Digital 3.0 es para ti si…
          </h3>
          <ul className="space-y-3" data-id="element-89">
            {forYouItems.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-90">
                <div className="flex-shrink-0 mt-0.5" data-id="element-91">
                  <div className="w-5 h-5 rounded-full bg-[#4CAF50]/10 flex items-center justify-center" data-id="element-92">
                    <Check className="w-3.5 h-3.5 text-[#4CAF50]" strokeWidth={3} data-id="element-93" />
                  </div>
                </div>
                <span className="text-[14px] md:text-[15px] text-[#444444] leading-snug" data-id="element-94">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>

        {/* Card 2: No es para ti */}
        <div className="mt-4 bg-white rounded-2xl p-5 shadow-lg border-2 border-[#FFB3B3]" data-id="element-95">
          <h3 className="text-[18px] font-bold text-[#222222] mb-5 text-center" data-id="element-96">
            No es para ti si…
          </h3>
          <ul className="space-y-3" data-id="element-97">
            {notForYouItems.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-98">
                <div className="flex-shrink-0 mt-0.5" data-id="element-99">
                  <div className="w-5 h-5 rounded-full bg-[#FF4D4D]/10 flex items-center justify-center" data-id="element-100">
                    <X className="w-3.5 h-3.5 text-[#FF4D4D]" strokeWidth={3} data-id="element-101" />
                  </div>
                </div>
                <span className="text-[14px] text-[#444444] leading-snug" data-id="element-102">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}